// extracted by css-extract-rspack-plugin
export default {"visualization":"pt03r"};